import { html, TemplateResult } from 'lit';
import { OffCanvasConfig } from '../../interfaces/off-canvas.interface';
import { COMMON_OFF_CANVAS_IDS } from '../../interfaces/common-off-canvas.interface';

export const COPY_AND_SHARE_OFF_CANVAS_DEFAULT_TITLE = 'Share link';
export const COPY_AND_SHARE_OFF_CANVAS_DEFAULT_LABEL = 'Shareable link:';

/**
 * Returns the configuration for the share wish list off-canvas
 *
 * @param title
 *
 */
export const getShareOffCanvasConfig = (title: TemplateResult): OffCanvasConfig => ({
  id: COMMON_OFF_CANVAS_IDS.COPY_AND_SHARE_LINK,
  title,
  closeTriggerId: 'copy-content-to-share',
  focusElement: `#content-to-share-input`,
});

export function getShareLinkOffCanvasContent(
  title: TemplateResult,
  strToShare: string,
  isNested = false,
  isCopyDisabled = false,
  onCopySuccess?: () => void
) {
  return html` <mhecomm-copy-and-share-off-canvas
    .label="${html`Shareable link:`}"
    .offCanvasTitle=${title}
    .data="${strToShare}"
    .isNested="${isNested}"
    .isCopyDisabled="${isCopyDisabled}"
    .onCopySuccess="${onCopySuccess}"
  ></mhecomm-copy-and-share-off-canvas>`;
}